import * as React from "react"
import { cn } from "@/lib/utils"

// Lightweight, Radix-free ScrollArea to avoid React hook/runtime conflicts
// API-compatible enough for our internal usage

type DivProps = React.HTMLAttributes<HTMLDivElement>

const ScrollArea = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "relative overflow-auto [scrollbar-width:thin] [scrollbar-color:hsl(var(--border))_transparent]",
          // Tailwind-based custom scrollbar for WebKit
          "[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border",
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)
ScrollArea.displayName = "ScrollArea"

// No-op ScrollBar export to satisfy existing imports
const ScrollBar = React.forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("hidden", className)} {...props} />
  )
)
ScrollBar.displayName = "ScrollBar"

export { ScrollArea, ScrollBar }
